import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerService } from '../../services/ServerService';

@Injectable({
  providedIn: 'root'
})
export class RespostaChatbotInstagramService extends ServerService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  // Listar todas as respostas do chatbot
  listeRespostas(filtros: any = {}): Promise<any> {
    return this.obtenha('/resposta-chatbot-instagram', filtros);
  }

  // Obter resposta específica por ID
  obtenhaResposta(id: number): Promise<any> {
    return this.obtenha(`/resposta-chatbot-instagram/${id}`, {});
  }

  // Obter resposta por chave
  obtenhaRespostaPorChave(chaveResposta: string): Promise<any> {
    return this.obtenha('/resposta-chatbot-instagram', { chaveResposta });
  }

  // Criar nova resposta
  insiraResposta(resposta: any): Promise<any> {
    return this.facaPost('/resposta-chatbot-instagram', resposta);
  }

  // Atualizar resposta existente
  atualizeResposta(id: number, resposta: any): Promise<any> {
    return this.http.put(`/resposta-chatbot-instagram/${id}`, resposta)
      .toPromise().then(this.retorno).catch(this.handleError);
  }

  // Remover resposta
  removaResposta(id: number): Promise<any> {
    return this.http.delete(`/resposta-chatbot-instagram/${id}`)
      .toPromise().then(this.retorno).catch(this.handleError);
  }

  // Listar apenas respostas ativas
  listeRespostasAtivas(): Promise<any> {
    return this.listeRespostas({ ativa: true });
  }

  // Validar se chave de resposta é única
  validaChaveResposta(chaveResposta: string, idResposta?: number): Promise<any> {
    const params = { chaveResposta };
    if (idResposta) {
      params['id'] = idResposta;
    }
    return this.obtenha('/resposta-chatbot-instagram/valida-chave', params);
  }

  // Inicializar configurações padrão para empresa nova
  inicializarConfiguracoesPadrao(): Promise<any> {
    return this.obtenha('/resposta-chatbot-instagram/inicializar-padrao', {});
  }
} 